/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AdminHardDeleteSyncEntitiesRequest} from '@cash-web/protos/squareup/cash/clientsync/service.pb'
import {AdminHardDeleteSyncEntitiesResponse} from '@cash-web/protos/squareup/cash/clientsync/service.pb'


export const adminHardDeleteSyncEntities = (request:AdminHardDeleteSyncEntitiesRequest, options?: CashRequestOptions) => post<AdminHardDeleteSyncEntitiesRequest, AdminHardDeleteSyncEntitiesResponse>("/2.0/cash/admin-hard-delete-sync-entities", request, {...options, rejectOnError: true })